var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lingdui-report-container"},[_c('report-ld-dw',{attrs:{"ssid":_vm.ssid,"isShowSsmc":_vm.isShowSsmc,"ssIsBm":'Y'}}),_vm._v(" "),_c('loading-com')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc1ae67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportXm/LingDuiReport.vue
// module id = null
// module chunks = 